import { render, staticRenderFns } from "./CompartirInformacionModalNuevo.vue?vue&type=template&id=b6ed55a4&scoped=true&"
import script from "./CompartirInformacionModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./CompartirInformacionModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./CompartirInformacionModalNuevo.vue?vue&type=style&index=0&id=b6ed55a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ed55a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b6ed55a4', component.options)
    } else {
      api.reload('b6ed55a4', component.options)
    }
    module.hot.accept("./CompartirInformacionModalNuevo.vue?vue&type=template&id=b6ed55a4&scoped=true&", function () {
      api.rerender('b6ed55a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/CompartirInformacionModalNuevo.vue"
export default component.exports